import { useRef, useEffect } from "react";
import { TicketData, HelpdeskStage } from "../../../../utils/types";
import TicketDescription from "./components/TicketDescription";
import { TicketHeader } from "./components/TicketHeader";
import { TicketHeaderShimmer } from "./components/TicketHeaderShimmer";
import { TicketDescriptionShimmer } from "./components/TicketDescriptionShimmer";

interface TicketOverviewProps {
  ticketId: string;
  ticketData?: TicketData;
  stagesData?: HelpdeskStage[];
  isTicketLoading?: boolean;
}

export const TicketOverview = ({
  ticketId,
  ticketData,
  stagesData,
  isTicketLoading,
}: TicketOverviewProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // this effect is used to get the height of the ticket header and set it as a CSS variable
  useEffect(() => {
    const headerEl = document.getElementById("ticket-header-root");
    if (!headerEl) return;

    const update = () => {
      const h = headerEl.getBoundingClientRect().height;
      containerRef.current?.style.setProperty(
        "--ticket-header-height",
        `${h}px`
      );
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(headerEl);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex-1 min-w-0 h-full flex flex-col bg-pure-white dark:bg-pure-white-dk overflow-y-auto"
    >
      <div
        id="ticket-header-root"
        className="shrink-0 border-b border-border-gray dark:border-border-gray-dk"
      >
        {isTicketLoading ? (
          <TicketHeaderShimmer />
        ) : (
          <TicketHeader
            ticketId={ticketId}
            ticketData={ticketData}
            stagesData={stagesData}
          />
        )}
      </div>
      {isTicketLoading ? (
        <TicketDescriptionShimmer />
      ) : (
        <TicketDescription
          ticketId={String(ticketData?.ticket_id ?? ticketId)}
          description={ticketData?.description}
          existingAttachments={ticketData?.attachments ?? []}
          ticketCategory={ticketData?.ticket_category}
        />
      )}
    </div>
  );
};
